export default __webpack_public_path__ + "static/components-do-0156ffcda04986c57d0e910135eb5b91ba4e01533ae34d2ebc5bd6ea9713f4d7.png";